import React from 'react';
import { Navbar as BootstrapNavbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import BrandMark from './BrandMark';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const userInitial = (user?.username || 'U').charAt(0).toUpperCase();

  const handleLogout = () => {
    logout();
  };

  return (
    <BootstrapNavbar className="app-navbar" variant="light" expand="lg" sticky="top" collapseOnSelect>
      <Container fluid="xl" className="app-navbar__inner">
        <LinkContainer to="/dashboard">
          <BootstrapNavbar.Brand className="app-brand">
            <span className="app-brand__mark"><BrandMark /></span>
            <span>StockHunt</span>
          </BootstrapNavbar.Brand>
        </LinkContainer>
        
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/dashboard">
              <Nav.Link>Overview</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/portfolio">
              <Nav.Link>Investments</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/assets">
              <Nav.Link>Assets</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/analysis">
              <Nav.Link>Planning</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/reports">
              <Nav.Link>Reports</Nav.Link>
            </LinkContainer>
            <NavDropdown title="Explore" id="explore-nav">
              <LinkContainer to="/stocks"><NavDropdown.Item>Stocks</NavDropdown.Item></LinkContainer>
              <LinkContainer to="/mutual-funds"><NavDropdown.Item>Mutual Funds</NavDropdown.Item></LinkContainer>
            </NavDropdown>
          </Nav>
          
          <Nav>
            <NavDropdown 
              title={
                <span className="app-user-menu">
                  <span className="app-user-menu__avatar" aria-hidden="true">{userInitial}</span>
                  <span>{user?.username || 'User'}</span>
                </span>
              } 
              id="basic-nav-dropdown"
              align="end"
            >
              <NavDropdown.Item disabled>
                <small className="text-muted">{user?.email}</small>
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <LinkContainer to="/help"><NavDropdown.Item>Help</NavDropdown.Item></LinkContainer>
              <LinkContainer to={{ pathname: "/portfolio", search: "?tab=settings" }}><NavDropdown.Item>Data settings</NavDropdown.Item></LinkContainer>
              {user?.is_superuser && <>
                <NavDropdown.Divider />
                <NavDropdown.Header>Admin Review</NavDropdown.Header>
                <LinkContainer to="/super-admin/corporate-actions"><NavDropdown.Item>Corporate actions</NavDropdown.Item></LinkContainer>
                <LinkContainer to="/super-admin/reports"><NavDropdown.Item>Report health</NavDropdown.Item></LinkContainer>
              </>}
              <NavDropdown.Item onClick={handleLogout}>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
